<template>
  <v-container fluid class="pa-0">
    <v-sheet ref="vsheet" style="background-color: transparent">
      <v-slide-group v-model="model" class="mx-0" show-arrows="desktop">
        <v-slide-item
          v-for="(item, index) in dataItems"
          :key="index"
          style="width: calc(100vw - 56px); max-width: 360px"
          v-touch="{
            left: (event) => onTouchLeft(event, index),
            right: (event) => onTouchRight(event, index),
          }"
        >
          <div class="ma-2">
            <v-card
              class="card-bg pa-3 card-container"
              :class="{ 'disabled-card': item.limit_reached }"
              outlined
              elevation="1"
              style="border: none; border-radius: 28px"
              :style="{
                background: site.color || '#fce4ec',
              }"
              :disabled="checkExpire(item.expires_at, item.limit_reached)"
              @click="confirmRedeem(item)"
            >
              <div class="wave-box">
                <div class="wave-sub-box">
                  <svg
                    style="
                      width: 100%;
                      transform: rotate(180deg) scaleX(-1);
                      margin-top: 24px;
                    "
                    viewBox="0 0 500 200"
                  >
                    <!-- d="M 0,100 C 150,200 350,0 500,100 L 500,00 L 0,0" -->
                    <path
                      fill="#ffffff80"
                      d="M 0,100 C 150,100 420,30 500,110 L 500,00 L 0,0"
                    ></path>
                  </svg>
                </div>
              </div>

              <div
                v-if="item.limit_reached"
                class="d-flex align-center cover-card-disable"
              >
                <div
                  class="d-flex justify-center align-center text-center"
                  style="width: 120px; margin-left: 2px"
                >
                  <div class="label">{{ $t("rewardLimitReached") }}</div>
                </div>
              </div>
              <div
                v-else-if="item.status == 'coming soon'"
                class="d-flex align-center cover-card-disable"
              >
                <div
                  class="d-flex justify-center align-center text-center"
                  style="width: 120px; margin-left: 2px"
                >
                  <div class="label">{{ $t("rewardComingSoon") }}</div>
                </div>
              </div>

              <div class="d-flex" style="gap: 14px; z-index: 1">
                <div
                  style="
                    width: 100px;
                    min-width: 100px;
                    height: 100px;
                    border-radius: 24px;
                    overflow: hidden;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <v-img
                    style="width: 100%; height: 100%"
                    :cover="true"
                    :aspect-ratio="1"
                    :lazy-src="require('@/assets/images/image.png')"
                    :src="item.image_url"
                  >
                  </v-img>
                </div>

                <div v-if="false" class="line-split-coupon-box">
                  <div class="line-split-coupon"></div>
                  <div class="line-split-coupon"></div>
                  <div class="line-split-coupon"></div>
                  <div class="line-split-coupon"></div>
                  <div class="line-split-coupon"></div>
                  <div class="line-split-coupon"></div>
                </div>

                <div
                  style="width: calc(100% - 132px)"
                  :style="{
                    color: getFontColorBasedOnBg(site.color || '#e91e63', 'bw'),
                  }"
                >
                  <p
                    class="description-label title-mission text-start mb-auto text-subtitle-2"
                  >
                    {{ item.name }}
                  </p>

                  <div
                    class="bottomleft text-start text-subtitle-2"
                    v-if="!checkExpire(item.expires_at)"
                  >
                    <div
                      v-if="
                        Array.isArray(item.point_used) &&
                        item.point_used.length > 0
                      "
                      class="d-flex align-center"
                      style="width: 100%"
                    >
                      <div class="mr-2">
                        <PointSymbol
                          :type="item.point_used[0].point_type_type"
                          :symbol="item.point_used[0].point_type_symbol"
                          :color="item.point_used[0].point_type_color"
                          :is_display="true"
                          :outlined_box="false"
                          :size="20"
                        />
                      </div>
                      <p
                        class="pa-0 pl-0 my-0 text-truncate"
                        style="width: 100%"
                      >
                        {{ item.point_used[0].point | commaPoint }}
                        {{ item.point_used[0].point_type_name }}
                      </p>
                    </div>
                  </div>
                  <div class="bottomleft text-start text-subtitle-2" v-else>
                    <v-img
                      :src="require('@/assets/images/expired.png')"
                      max-height="20"
                      max-width="20"
                      class="ma-1 d-block"
                    ></v-img>
                    <p class="pa-0 my-1 pl-0 text-truncate">
                      {{ $t("expireTime") }}
                    </p>
                  </div>
                </div>
              </div>
            </v-card>
            <!-- </div> -->
          </div>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>

    <div
      class="d-flex d-xxl-none d-xl-none d-lg-none d-md-none d-sm-none justify-center"
      style="gap: 4px"
    >
      <div
        v-if="dataItems.length > 1"
        class="dot"
        :style="{
          backgroundColor: positionSlider == 'start' ? site.color : '#C8C8C8',
        }"
      ></div>
      <div
        v-if="dataItems.length > 2"
        class="dot"
        :style="{
          backgroundColor: positionSlider == 'middle' ? site.color : '#C8C8C8',
        }"
      ></div>
      <div
        v-if="dataItems.length > 1"
        class="dot"
        :style="{
          backgroundColor: positionSlider == 'end' ? site.color : '#C8C8C8',
        }"
      ></div>
    </div>

    <v-dialog v-model="dialogAddFavorite" persistent max-width="290">
      <v-card>
        <v-card-text class="text-h6 text-center mt-0 pa-4">
          {{ $t("confirmAdd") }} <br />
          <span :style="{ color: site.color }" class="font-weight-bold">{{
            item.name
          }}</span
          ><br />
          {{ $t("inYourFav") }} ?
        </v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            :color="site.color"
            class="rounded-lg white--text"
            depressed
            @click="addFavorite()"
          >
            {{ $t("confirm") }}
          </v-btn>
          <v-btn
            :color="site.color"
            class="rounded-lg"
            outlined
            @click="dialogAddFavorite = false"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDeleteFavorite" persistent max-width="290">
      <v-card>
        <v-card-text class="text-h6 text-center mt-0 pa-4" :color="site.color">
          {{ $t("confirmDelete") }} <br />
          <span :style="{ color: site.color }" class="font-weight-bold">{{
            item.name
          }}</span
          ><br />
          {{ $t("fromYourFav") }} ?
        </v-card-text>

        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            :color="site.color"
            class="rounded-lg white--text"
            depressed
            @click="deleteFavorite()"
          >
            {{ $t("confirm") }}
          </v-btn>
          <v-btn
            :color="site.color"
            class="rounded-lg"
            outlined
            @click="dialogDeleteFavorite = false"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--dialog detail reward -->
    <dialogDetailReward
      :dialogDetail="dialogDetail"
      :item="item"
      :site="site"
      :keyComponent="keyComponent"
      @addFavorite="addFavorite"
      @deleteFavorite="deleteFavorite"
      @redeemRewardFinal="redeemRewardFinal"
      @close="dialogDetail = false"
    />

    <!-- Fern: Confirm Redeem Final dialog -->
    <DialogConfirmRedeemFinal
      :dialogConfirmRedeemFinalVisible="dialogConfirmRedeemFinalVisible"
      :site="site"
      :item="item"
      :quantity="quantity"
      @close="closeConfirmDialog()"
    />
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import moment from "moment";
import { getFontColorBasedOnBg } from "@/config/general-function";
import dialogDetailReward from "./reward/dialogDetail.vue";
import DialogConfirmRedeemFinal from "@/components/reward/dialogConfirmRedeemFinal.vue";
import PointSymbol from "./point/point-symbol.vue";

export default {
  inject: ["isAppLoading"],
  props: ["dataItems", "site"],
  components: {
    dialogDetailReward,
    DialogConfirmRedeemFinal,
    PointSymbol,
  },
  data: () => ({
    model: null,
    dialogDeleteFavorite: false,
    dialogDetail: false,
    dialogAddFavorite: false,
    dialogConfirmRedeemFinalVisible: false,
    item: "",
    keyComponent: 0,
    quantity: null,
    positionSlider: "start",
  }),
  methods: {
    getFontColorBasedOnBg(param, param2) {
      const res = getFontColorBasedOnBg(param, param2);
      return res;
    },

    // ========== ========== Favorite ========== ==========
    addFavorite() {
      Axios.post(`reward/addFevoriteItem`, {
        reward_id: this.item.id,
      })
        .then((res) => {
          if (res.data.status == "success") {
            this.item.is_fevorite = !this.item.is_fevorite;
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 1500,
            });
            Toast.fire({
              icon: "success",
              title: res.data.message,
            });
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: JSON.stringify(err.response.data.message),
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },
    deleteFavorite() {
      Axios.delete(`reward/deleteFavoriteItem`, {
        data: { reward_id: this.item.id },
      })
        .then((res) => {
          if (res.data.status == "success") {
            this.item.is_fevorite = !this.item.is_fevorite;
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 1500,
            });
            Toast.fire({
              icon: "success",
              title: res.data.message,
            });
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: JSON.stringify(err.response.data.message),
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },

    // ========== ========== Map ========== ==========
    checkExpire(date, limit_reached) {
      if (limit_reached) return limit_reached;
      return moment().isAfter(date, "day");
    },

    // ========== ========== ========== ==========
    confirmRedeem(item) {
      if (item.limit_reached) return;
      this.item = item;
      Axios.get(`reward/getReward`, {
        params: {
          reward_id: item.id,
        },
      })
        .then((res) => {
          if (res.data.status == "success") {
            const { data } = res.data;
            this.item = { ...this.item, ...data };
            this.dialogDetail = true;
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: JSON.stringify(err.response.data.message),
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },
    closeConfirmDialog() {
      this.dialogDetail = true;
      this.dialogConfirmRedeemFinalVisible = false;
    },
    redeemRewardFinal(quantity) {
      this.quantity = quantity;
      this.dialogDetail = false;
      this.dialogConfirmRedeemFinalVisible = true;
    },

    // ========== ========== ========== ==========
    onTouchLeft() {
      const v_slide_group__content =
        this.$refs.vsheet?.$el?.getElementsByClassName(
          "v-slide-group__content"
        );
      if (v_slide_group__content?.length > 0) {
        const count = this.dataItems.length;
        const widthAvg = 300;
        const element = v_slide_group__content[0];
        const transform = getComputedStyle(element).transform;
        if (transform) {
          const match = transform.match(/matrix\((.*)\)/);
          if (match) {
            const values = match[1].split(",");
            const translateX = parseFloat(values[4].trim());
            if (count > 1) {
              const translateXAbs = Math.abs(translateX);
              if (translateXAbs >= widthAvg * (count - 1) + widthAvg / 2) {
                this.positionSlider = "end";
              } else if (translateXAbs >= widthAvg / 2) {
                this.positionSlider = "middle";
                if (count == 2) {
                  this.positionSlider = "end";
                }
              }
            }
          }
        }
      }
    },
    onTouchRight() {
      const v_slide_group__content =
        this.$refs.vsheet?.$el?.getElementsByClassName(
          "v-slide-group__content"
        );
      if (v_slide_group__content?.length > 0) {
        const count = this.dataItems.length;
        const widthAvg = 300;
        const element = v_slide_group__content[0];
        const transform = getComputedStyle(element).transform;
        if (transform) {
          const match = transform.match(/matrix\((.*)\)/);
          if (match) {
            const values = match[1].split(",");
            const translateX = parseFloat(values[4].trim());
            if (count > 1) {
              const translateXAbs = Math.abs(translateX);
              if (translateXAbs <= widthAvg / 1.5) {
                this.positionSlider = "start";
              } else if (
                translateXAbs <=
                widthAvg * (count - 1) + widthAvg / 1.5
              ) {
                this.positionSlider = "middle";
                if (count == 2) {
                  this.positionSlider = "end";
                }
              }
            }
          }
        }
      }
    },
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("D MMMM YY");
    },
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>

<style scoped>
.card-container {
  position: relative;
  display: flex;
  flex-direction: column;
}
.disabled-card {
  /* background-color: #00000033; */
}

.bottomleft {
  display: flex;
  align-items: center;
  margin-top: auto;
  margin-bottom: 0px;
  font-size: 18px;
}

.container1 {
  position: relative;
}
.btn-close {
  position: absolute;
  margin-bottom: -100px;
  z-index: 888;
  right: 0;
}

.cover-card-disable {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 2;
  /* background-color: #00000099; */
  /* background-color: #FFFFFF99; */
}
.cover-card-disable .label {
  font-size: 16px;
  font-weight: 500;
  /* color: #FFFFFF; */
  color: #000000;
  border-radius: 16px;
  background-color: #ffffff;
  padding: 0px 8px;
}

.description-label {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.coupon {
  background-color: #fce4ec;
  cursor: pointer;
  border-radius: 10px;
  overflow: hidden;
  margin: auto;
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.4));
  display: flex;
  align-items: stretch;
  position: relative;
  text-transform: uppercase;
}
.coupon::before,
.coupon::after {
  content: "";
  position: absolute;
  top: 0;
  width: 50%;
  height: 100%;
  z-index: -1;
}

.coupon::before {
  left: 0;
  /* background-image: radial-gradient(
    circle at 0 50%,
    transparent 12px,
    #fce4ec 13px
  ); */
}

.coupon::after {
  right: 1px;
  /* background-image: radial-gradient(
    circle at 100% 50%,
    transparent 12px,
    #fce4ec 13px
  ); */
}

.line-split-coupon-box {
  width: 1px;
  height: 100px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.line-split-coupon {
  width: 100%;
  height: 16px;
  background-color: #757575;
}

.wave-box {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
}
.wave-sub-box {
  margin-left: -12px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 28px;
}
.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #c8c8c8;
}
</style>
